module.exports = __webpack_public_path__ + "static/map-95dc984bf344aac37e12cbf2c495c14f.webp";